<template>
  <div :class="getStatusClass">
    <span v-if="text">
      {{text}}
    </span>
    <span v-else>
      {{getStatusLabel}}
    </span>
  </div>
</template>

<script>
export default {
  data () {
    return {
      status: $store.state['voip-testing-panel-state'].callTestsStatusesObject
    }
  },
  props: {
    callTestStatus: {
      default: false
    },
    text: {
      default: false
    }
  },
  computed: {
    getStatusLabel () {
      if (this.params) {
        return this.status[this.params.data.status].label
      } else {
        return this.status[this.callTestStatus].label
      }
    },
    getStatusClass () {
      if (this.params) {
        return this.status[this.params.data.status].class
      } else {
        return this.status[this.callTestStatus].class
      }
    }
  }
}
</script>
